// Service
import { errorLogService } from '../services/error.service';
// Types
import { ErrorType } from '../types/error.type';
// Utils
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';

const errorLogResolver = async (props: ErrorType): Promise<[boolean]> => {
  const [, { status }] = await errorLogService(props);

  return [requestHasSuccessStatus(status)];
};

export { errorLogResolver };
